import { dispatch } from "hf-rt";

const initialState = {
  scale: false
};

export default {
  name: "scaleProduct",
  actions: {
    startScaleProduct: function(bool) {
      dispatch({ type: "START_SCALE_PRODUCT", bool });
    }
  },
  reducers: function(state = initialState, action) {
    switch (action.type) {
      case "START_SCALE_PRODUCT":
        return {
          ...state,
          scale: action.bool
        };
      default:
        return state;
    }
  }
};
